window.addEventListener('DOMContentLoaded', function () {
    var isTypeurl = window.location.href;//判断是否是详情页

    setTimeout(Txtinput, 3000);
    setTimeout(hideBlank, 2000);
    setTimeout(Addinfo, 1000);
    setTimeout(eq_page, 3000);


    var makeupTheDifferenceQty = '';
    if (getUrlParam('_qty') != null) {
        makeupTheDifferenceQty = getUrlParam('_qty');
    } else {
        makeupTheDifferenceQty = getUrlParam('_amount');
    }
    if (makeupTheDifferenceQty != null) {
        $("#quantity").val(makeupTheDifferenceQty);
    }

      if(getUrlParam('_salesmanager') != null){
        $("#sales-manager").removeAttr("disabled");   
        $("#sales-manager").val(getUrlParam('_salesmanager'));
    }


    if (navigator.userAgent.match(/mobile/i)) {
        var headerHeight = $("#header").height();
        $('.add_to_cart').click(function () {
            var menHeight = ($("#variant_select_1").offset().top - headerHeight - 70);
            var men = $('#variant_select_1').val();
            if (men == null) {
                $('html,body').animate({ scrollTop: menHeight }, 100);
            }
        })
    }
    $('#mask-mi').click(function () {
        $(this).css('display', 'none');
        $('#mi-popup-kk').css('display', 'none');
        document.getElementById("buttom-x").style.display = 'none';//wwh8.4新增
        $(".touchevents").css('overflow', '')//wwh8.5新增
        $('.font-popup-kk').css('display', 'none'); // hf 25.4.23
    });

    $('.size-cm').click(function () {
        $(this).addClass('size_checked')
        $('#inTable').addClass('size_hidden');;
        $('#cmTable').removeClass('size_hidden');
        $('.size-in').removeClass('size_checked')
    })

    $('.size-in').click(function () {
        $(this).addClass('size_checked');
        $('#cmTable').addClass('size_hidden');
        $('#inTable').removeClass('size_hidden');
        $('.size-cm').removeClass('size_checked')
    })


    //     pc端
    $('.homepage-slideshow.mobile_hide ').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });
    //     移动端
    $('.homepage-slideshow.pc_hide').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    //wwh8.4新增
    $('.mi-close-custom').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
        document.getElementById("buttom-x").style.display = 'none';
        $(".touchevents").css('overflow', '')
    });

    $('.header__search span').eq('1').click(function () {
        $('.search_field').css('display', 'flex').animate({ top: "30px" }, 50)
        //wwh修改search5.12
        $('.search_field_custom').css('display', 'inline').animate({ top: "30px" }, 50)
        $('#mask-search').css('display', 'block')
        $('html').css('overflow', 'hidden');

    })
    //wwh修改(手机端search点击关闭隐藏)
    /*--------------------------*/
    $('.search_container_svg_custom_mobile').click(function () {
        $('.dropdown_container_custom_mobile').hide()
        $('html').css('overflow', 'auto');
        $("body").removeClass("is-active")
    })
    $('.icon-search-mobile-click-scroll-custom').click(function () {
        if ($(window).width() < 798) {
            $('html').css('overflow-y', 'hidden');
        }
    })
    /*--------------------------*/
    $('#mask-search , .search-modal__close-button').click(function () {
        $('.search_field').removeAttr('style')
        $('#mask-search').removeAttr('style')
        $('html').css('overflow', 'auto');
    })

    var interval1 = setInterval(() => {
        var Material = $('input[value="Blank(No Name/Number)"]');
        var properties = $('input[name="properties[Material*]"]').parent();
        var bcpo = $('#bcpo');
        var text = bcpo.find('input[type="text"]').parent();
      // 6.24 新修改
        var file = $("input[name='properties[Upload Logo]'],input[name='properties[1ST Upload Logo]'],input[name='properties[2ND Upload Logo]'],input[name='properties[Team Logo]'],input[name='properties[Back Logo]']");
        var button = $("input[name='properties[A/C Patch on Left Chest (Optional)]'],input[name='properties[Logo Location(Optional)]'],input[name='1ST properties[Logo Location(Optional)]'],input[name='properties[2ND Logo Location(Optional)]'],input[name='properties[Logo Location(Optional)][]'] ,input[name='properties[1ST Logo Location(Optional)][]'] , input[name='properties[2ND Logo Location(Optional)][]']");   
        var Logo_Location = $.trim($('input[name="properties[Logo Location(Optional)][]"]:checked ,input[name="properties[Logo Location(Optional)]"]:checked ,input[name="properties[1ST Logo Location(Optional)][]"]:checked , input[name="properties[2ND Logo Location(Optional)][]"]:checked ,input[name="properties[1ST Logo Location(Optional)]"]:checked,input[name="properties[2ND Logo Location(Optional)]"]:checked').val());
        var Upload_Logo = $('input[name="properties[Upload Logo]"] ,input[name="properties[1ST Upload Logo]"] ,input[name="properties[2ND Upload Logo]"]').parents('.bcpo-file');
        var Location  = $('input[name="properties[Logo Location(Optional)][]"],input[name="properties[Logo Location(Optional)]"],input[name="properties[1ST Logo Location(Optional)][]"] ,input[name="properties[2ND Logo Location(Optional)][]"] ,input[name="properties[1ST Logo Location(Optional)]"],input[name="properties[2ND Logo Location(Optional)]"]').parents('.selector-wrapper')
        var _2ndLocation = $('input[name="properties[2ND Logo Location(Optional)][]"], input[name="properties[2ND Logo Location(Optional)]"]').parents('.selector-wrapper');

        var style = $("input[name='properties[Style]']");
        var inside_lining = $("input[name='properties[Inside Lining]']");
        var sleeves =  $("input[name='properties[Sleeves]']");
        var design  =$('.single-option-selector.bcpo-auto-images').find('input');
        var Back_Logo =  $('input[name="properties[Back Logo]"]')
        var Back_Number =  $('input[name="properties[Back - Number]"]')
        var font_style = $('select[name="properties[Front Style]"]')
        if (bcpo.length > 0) {
         $('textarea[name="properties[Product Note]"]').parents('.selector-wrapper').attr('style', 'display: none !important;');
            // 关于漏单
            setTimeout(remove_add_cart, 3000)
            if (isTypeurl.indexOf('products') != -1) {
                var goods_name = ($('h1.product_name').text()).toLowerCase();
                add_button(goods_name);
                setTimeout(AddSize(goods_name), 1000);
                setTimeout(productCus(goods_name), 1000);
            }

            properties.find('label').click(function () {
                if ($(this).siblings('input').val().indexOf('Blank') < 0) {
                    bcpo.find('input[type="text"]').attr("disabled", false);
                    file.attr("disabled", false);
                    button.attr("disabled", false);
                } else {
                    bcpo.find('input[type="text"]').attr("disabled", true);
                    file.attr("disabled", true);
                    button.attr("disabled", true);
                }
            })

            button.next('label').click(function () {
          if ($(this).prev('input').attr("name") == 'properties[A/C Patch on Left Chest (Optional)]') {
                if ($(this).prev('input').val() == 'None') {
                    $('input[value="Left Chest"]').parents('.bcpo-button-parent').show();
                } else {
                    const $leftChest = $('input[value="Left Chest"]');
                    if ($leftChest.is(':checked')) {
                        const html = '<div class="tip-top">Please deselect Left Chest before choosing this option.</div>';
                       $(this).find('.tip-top').remove();
                        $(this).append(html);
                        setTimeout(removeTip, 3000);
                        $(this).parents('.selector-wrapper').find('input[value="None"]').prop('checked', true);
                        return false;
                    }
                    $leftChest.parents('.bcpo-button-parent').hide();
                }
            }

                if ($(this).prev('input').attr("disabled") == "disabled") {
                    var html = '<div class="tip-top"> Please select right Material !</div>';
                    $(this).find('.tip-top').remove();
                    text.find('.tip-top').remove();
                    $(this).append(html);
                    setTimeout(removeTip, 3000);
                }
                if ($(this).text().indexOf("None") == -1 && Material.is(":checked") == false) {
                    Material.parent('.bcpo-button-parent').css('display', 'none');
                } else {
                    Material.parent('.bcpo-button-parent').css('display', 'inline-block');
                }

                if ($(this).prev('input').attr('name') == 'properties[Logo Location(Optional)][]' || $(this).prev('input').attr('name') == 'properties[Logo Location(Optional)]') {
                    // hide_Upload($(this),Upload_Logo)
                }

            })

            $('.bcpo-front-button-label').click(function () {
                    if ($('.bubble.tip-top').length > 0) {
                      $('.bubble.tip-top').addClass('active');
                    }
            })


            text.click(function () {
                if ($(this).find('input').attr("disabled") == "disabled") {
                    var html = '<div class="tip-top"> Please select right Material !</div>';
                    $(this).find('.tip-top').remove();
                    text.find('.tip-top').remove();
                    $(this).append(html);
                    setTimeout(removeTip, 3000);
                }
            })

            if (Material.is(":checked")) {
                Material.removeAttr('checked')
                properties.find('input').eq(0).trigger("click");
            }
            if (Material.length < 1 && (goods_name.indexOf('pants') > -1 || goods_name.indexOf('hat') > -1)) {
                $('#add_to_cart').prop('disabled', 'disabled')
            }

            // Choose Neckline
            var Shape = $('input[name="properties[Choose Neckline]"]').parents('.bcpo-buttons');
            Shape.find('.bcpo-button-parent').each(function () {
                var Shape_val = $(this).find('input').val();
                var Shape_img = '';
                var Shape_title = ''
                if (Shape_val.indexOf('V Shape') != -1) {
                    Shape_img = 'https://bigtur.360yituo.com/turntable/img/V_Shape.jpg'
                    Shape_title = 'V Shape'
                } else if (Shape_val.indexOf('Round Shape') != -1) {
                    Shape_img = 'https://bigtur.360yituo.com/turntable/img/Round_Shape.jpg'
                    Shape_title = ' Round Shape'
                }
                $(this).find('.bcpo-front-button-label').html('<img src="' + Shape_img + '"><p>' + Shape_title + '</p>').addClass('label_img');
            })

            // 球衣 去掉 shorts 选项
          if (style.length > 0) {
              hide_Shorts('Top');
              style.each(function () {
                  const $this = $(this);
                  const $label = $this.next('label');  
                  $label.off('click').on('click', function () {
                      const selectedValue = $this.val();
                      hide_Shorts(selectedValue);
                  });
              });
          }



    // Logo Location  06.24 新增
            if (Logo_Location == 'None') {
              Upload_Logo.attr('style', 'display: none !important;');
            }

$('body').on("click", '.bcpo-button-parent', function () {
    const $input = $(this).find('input');
    const name = $input.attr('name');
    const this_val = $input.val();
    const valueBox = $(this).parents('.bcpo-buttons').find('.bcpo_value');

    // 匹配是否是 Logo Location 字段（支持有无 []，有无前缀）
    const logoLocationRegex = /^properties\[((\d+(ST|ND|RD|TH)\s)?Logo Location\(Optional\))\](\[\])?$/;
    const isLogoLocation = name && name.match(logoLocationRegex);
    if (!isLogoLocation) return;

    // 提取前缀（如 1ST / 2ND），无则为空字符串
    const prefixMatch = name.match(/^properties\[(\d+(ST|ND|RD|TH))? ?Logo Location\(Optional\)\]/);
    const prefix = prefixMatch && prefixMatch[1] ? prefixMatch[1].trim() : '';

    // 找对应 Upload Logo 块
    let $uploadLogo = null;
    if (prefix) {
        $uploadLogo = $('input[name="properties[' + prefix + ' Upload Logo]"]').closest('.bcpo-file');
    } else {
        $uploadLogo = $('input[name="properties[Upload Logo]"]').closest('.bcpo-file');
    }

    // 当前字段是否为多选（checkbox）
    const isMultiple = name.endsWith('[]');

    // 获取当前组所有选中值
    const $groupInputs = $(`input[name="${name}"]`);
    const $checkedInputs = $groupInputs.filter(':checked');
    const selectedValues = $checkedInputs.map(function () {
        return $(this).val();
    }).get();

    // 自动取消冲突选项
    if (this_val === 'None') {
        $groupInputs.not('[value="None"]').prop('checked', false);
    } else {
        $groupInputs.filter('[value="None"]').prop('checked', false);
    }

    // 重新获取已选值
    const refreshedValues = $groupInputs.filter(':checked').map(function () {
        return $(this).val();
    }).get();

    // 控制 Upload Logo 显示
    if (refreshedValues.length === 0 || refreshedValues.includes('None')) {
        $uploadLogo.get(0).style.setProperty('display', 'none', 'important');
        $uploadLogo.css('border-radius', '0px');
        $('.bcpo-buttons').last().css('border-radius', '0px 0px 10px 10px');
    } else {
        $uploadLogo.removeAttr('style').show();
        $uploadLogo.css('border-radius', '0px 0px 10px 10px');
        $('.bcpo-buttons').last().css('border-radius', '0px');
    }

    // 更新按钮文字
    if (valueBox.text().includes('None') && this_val !== 'None') {
        valueBox.text(valueBox.text().replace('None', ''));
    } else if (this_val === 'None') {
        valueBox.text('None');
    }

    // 互斥隐藏按钮逻辑
    const is1st = name.includes('1ST Logo Location');
    const is2nd = name.includes('2ND Logo Location');

    // 获取 Style 当前选中值
    const styleSelected = $("input[name='properties[Style]']:checked").val();
    // 目标互斥组
    const $targetGroup = is1st
        ? $('input[name^="properties[2ND Logo Location"]').closest('.selector-wrapper')
        : is2nd
            ? $('input[name^="properties[1ST Logo Location"]').closest('.selector-wrapper')
            : null;

    if ($targetGroup && $targetGroup.length > 0) {
        if (refreshedValues.includes('None')) {
            $targetGroup.find('.bcpo-button-parent').show();

            // style不是top时，互斥组里的shorts显示
            if (styleSelected !== 'Top') {
                $targetGroup.find('input[value="Shorts"]').parent().show();
            }
        } else {
            $targetGroup.find('.bcpo-button-parent').show();
            refreshedValues.forEach(val => {
                $targetGroup.find('.bcpo-button-parent').filter(function () {
                    return $(this).find('input').val() === val;
                }).hide();
            });

            // 如果 style 是 Top，互斥组隐藏 Shorts 并取消勾选
            if (styleSelected === 'Top') {
                const shortsInTarget = $targetGroup.find('input[value="Shorts"]').parent();
                $targetGroup.find('input[value="Shorts"]').prop('checked', false);
                shortsInTarget.hide();
            } else {
                // style不是top，shorts显示
                $targetGroup.find('input[value="Shorts"]').parent().show();
            }
        }

        // 准确根据前缀找到对应 Upload Logo 区块
        let targetPrefix = '';
        if (is1st) targetPrefix = '2ND';
        else if (is2nd) targetPrefix = '1ST';

        if (targetPrefix) {
            const $targetUploadLogo = $('input[name="properties[' + targetPrefix + ' Upload Logo]"]').closest('.bcpo-file');
            const hasTargetUpload = $targetUploadLogo.find('.bigtur_upload_img_item').length > 0;

            if (hasTargetUpload) {
                $targetGroup.find('.bcpo-button-parent').filter(function () {
                    return $(this).find('input').val() === 'None';
                }).hide();
            } else {
                $targetGroup.find('.bcpo-button-parent').filter(function () {
                    return $(this).find('input').val() === 'None';
                }).show();
            }
        }
    }

    // 当前组 Upload Logo 是否有图片，有则隐藏 None 按钮
    const hasCurrentUpload = $uploadLogo.find('.bigtur_upload_img_item').length > 0;
    if (hasCurrentUpload) {
        $(this).parent().find('.bcpo-button-parent').filter(function () {
            return $(this).find('input').val() === 'None';
        }).hide();
    } else {
        $(this).parent().find('.bcpo-button-parent').filter(function () {
            return $(this).find('input').val() === 'None';
        }).show();
    }
});

              // Logo Location  07.23 新增
            if (Logo_Location == 'None') {
              Upload_Logo.attr('style', 'display: none !important;');
            }
          if (_2ndLocation.length > 0) {
             _2ndLocation.attr('style', 'display: none !important;');
             _2ndLocation.after(`
              <div class="add-more-logo-wrapper" style="margin: 10px 0px">
               <div class="add-more-logo-btn">
               <img src="https://cdn.shopify.com/s/files/1/0445/3587/3698/files/SC.png?v=1753151153" style="height: 28px;width: 28px !important;">
               <span>Add More LOGO</span>
               </div>
              </div>
            `);
          _2ndLocation.find('.bcpo-button-parent:last').after(`
          <div class="delete-2nd-logo-btn-wrapper">
            <span class="delete-2nd-logo-btn delete-logo-btn-circle">&times;</span>
          </div>
        `);

          $('body').on('click', '.add-more-logo-btn', function () {
            // 显示 2ND Logo 的位置选择区域
            const $secondLogoLocation = $('input[name="properties[2ND Logo Location(Optional)]"], input[name="properties[2ND Logo Location(Optional)][]"]').closest('.selector-wrapper');
            $secondLogoLocation.show();
          
            // 隐藏“Add More Logo”按钮
            $(this).hide();
          });
  
            $('body').on('click', '.custom-modal-back', function () {
              $('.custom-modal-overlay').remove();
            });
            
            $('body').on('click', '.custom-modal-continue', function () {
              _2ndLocation.show();
              $('.add-more-logo-btn').hide();
              $('.custom-modal-overlay').remove();
            });

            $('body').on('click', '.delete-2nd-logo-btn-wrapper', function () {
              $('input[type="file"][name="properties[2ND Upload Logo]"]').val('');
              $('input[type="file"][name="properties[2ND Upload Logo]"]').closest('.bcpo-file').find('.bigtur_upload_img_item').remove();
              const $noneBtn = _2ndLocation.find('.bcpo-button-parent').has('input[value="None"]');
              $noneBtn.find('label').trigger('click');
              _2ndLocation.attr('style', 'display: none !important;');
              $noneBtn.css('display', 'inline-block');
              $('.add-more-logo-btn').show();
  
            });

            $('body').on('click', '.delete-logo-btn-wrapper', function () {
              // 找到外层的 wrapper
              const $wrapper = $(this).closest('.single-option-selector');
            
              // 找到被选中的 radio input
              const $checkedRadio = $wrapper.find('input[type="radio"]:checked');
              const value = $checkedRadio.val();
              const name = $checkedRadio.attr('name'); // 比如 "properties[1ST Logo Location(Optional)]"
            
              if (!name) return;
            
              // 判断是 1ST 还是 2ND
              let logoKey = '';
              if (name.includes('1ST')) {
                logoKey = '1ST';
              } 
            
              if (logoKey) {
                // 找到对应上传 input
                const $uploadInput = $(`input[type="file"][name="properties[${logoKey} Upload Logo]"]`);
                const $wrapperFile = $uploadInput.closest('.selector-wrapper');
                const $wrapper = $(this).closest('.selector-wrapper');
               $wrapperFile.find('.bigtur_upload_img_item_del').trigger('click')
                $wrapper.find('input[type="checkbox"][value="None"],input[type="radio"][value="None"]').trigger('click');
                $wrapper.find('input[type="checkbox"][value="None"],input[type="radio"][value="None"]').parents('.bcpo-button-parent').show();
                $(this).remove()
          
              }
            });
            
          }

// 07.23新增结束

          // inside_lining

          if(inside_lining.length>0){
            inside_lining.next('label').on({
            mouseover: function () {
              var html = '';
             if($(this).siblings('input').val() == 'Lightweight'){
               html = "<div class='Lightweight_title tip-top Lightweight'>Lightweight satin lining has polyester fiber fill material.<br> Thinner jacket, ideal for warmer climate.</div>"
             }else{
               html = "<div class='Lightweight_title tip-top Quilted'>Quilted satin lining has poly cotton  fiber fill material.<br>Thicker jacket, idea for colder climate. </div>"
             }
              if($(window).width() < 764){
                $(this).parents('.single-option-selector').append(html);
                $('.Lightweight_title').slideDown();    
              }else{
                    $(this).stop(true, true).after(html);
              }
          
            },
            mouseout: function () {      
           if($(window).width() < 764){
                $(this).parents('.bcpo-button-parent').siblings('.Lightweight_title').stop(true, true).remove();
                
              }else{
                $(this).siblings('.Lightweight_title').stop(true, true).remove();
              }
            }
              
            });
            
          }
                $('.question_file').on({
                    mouseover: function () { 
                      if (!$(this).parents('.selector-wrapper').find('.wen-div-css-mobile').hasClass('wen-div-css-pc')) {
                          $(this).parents('.selector-wrapper').find('.wen-div-css-mobile').stop(true, true).slideToggle()
                        }
                    },
                    mouseout: function () { 
                      if (!$(this).parents('.selector-wrapper').find('.wen-div-css-mobile').hasClass('wen-div-css-pc')) {
                           $(this).parents('.selector-wrapper').find('.wen-div-css-mobile').stop(true, true).slideToggle()
                      }  
                    }
                });

           $('.question_buttons').click(function () {
              $(this).parents('.bcpo-default').find('.bubble.tip-top').stop(true, true).slideDown();   
              $('.bubble.tip-top').hasClass('active') ? $('.bubble.tip-top').removeClass('active') : '';
           })
          
          $(document).on('click', function(event) {
            var target = $(event.target);
            if (!target.closest('.question_buttons').length) {
              $('.bubble.tip-top').slideUp();
            }
          });

          var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if (mutation.type === 'childList') {
                  var bcpoValue = $(mutation.target).closest('.selector-wrapper').find('.bcpo-value');
                  if (bcpoValue.text().includes('Leather') && !bcpoValue.text().includes('Leather (Faux Leather)')) {
                      bcpoValue.contents().filter(function() {
                          return this.nodeType === 3 && this.nodeValue.includes("Leather");
                      }).each(function() {
                          this.nodeValue = this.nodeValue.replace("Leather", "Leather (Faux Leather)");
                      });
                  }
              }
          });
      });

      sleeves.click(function () {
          var bcpoValue = $(this).parents('.selector-wrapper').find('.bcpo-value');
          observer.observe(bcpoValue[0], { childList: true, subtree: true });
      });

          if(design.length >0){
              if(design.not(':checked')){
              var isDesign1 = design.not(':checked').val().replace(/\(.*?\)/, '') === 'Design 1';
            if(isDesign1){
                Back_Number.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
            }else{
               Back_Logo.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
            }    
          }
          design.on('click', function() {
          var val_variants = $(this).val(); 
          var isDesign1 = val_variants.replace(/\(.*?\)/, '') === 'Design 1';  // 判断是否是Design 1

          // 根据isDesign1来控制Back Logo的显示和禁用
          if (isDesign1) {
              Back_Logo.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
          } else {
              Back_Logo.prop('disabled', false).parents('.selector-wrapper').removeAttr('style')
          }
      
          // 根据isDesign1来控制Back Number的显示和禁用
          if (isDesign1) {
              Back_Number.prop('disabled', false).parents('.selector-wrapper').removeAttr('style')
          } else {
              Back_Number.prop('disabled', true).parents('.selector-wrapper').css("cssText", "display: none !important;")
          }
      });
          }

           //   Blank Explanation 提示

        if ($.inArray("Blank Explanation", bcpo_product.tags) !== -1) {
              const html = `<div class="wen-div-css-mobile"><span style="color:#524e4e;">Important: A blank style removes customization but keeps the base pattern. For a solid color base, choose the 'Solid Color' series.</span></div>`
               Material.parent().after(html)  
                  Material.click(function() {
                    $(".wen-div-css-mobile").stop(true, true).slideDown();           
                    setTimeout(function() {
                      $(".wen-div-css-mobile").stop(true, true).slideUp();
                    }, 5000); 
                  });

          }


          
            clearInterval(interval1);
        }
    }, 1000);



    if (isTypeurl.indexOf('customer-feedback') != -1) {
        var interval2 = setInterval(() => {
            var radio_question = $('.radio-question');
            if (radio_question.length > 0) {
                $('.radio-question , .label-question').click(function () {
                    $(this).parents('.div-radio-question').siblings().find('input').removeAttr("checked");
                    $(this).parents('.div-radio-question').children('input').attr('checked', 'checked');
                })
                $('.radio-question , .label-question').mouseover(function () {
                    var s = event.fromElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '#eaf0fe')
                    }
                })
                $('.radio-question , .label-question').mouseout(function () {
                    var s = event.toElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '')
                    }
                })
                $('.div-radio-question').click(function () {
                    $(this).siblings().find('input').removeAttr("checked");
                    $(this).children('input').attr('checked', 'checked');
                })
                $('.div-radio-question').mouseover(function () {
                    var s = event.fromElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '#eaf0fe')
                    }

                })
                $('.div-radio-question').mouseout(function () {
                    var s = event.toElement || event.relatedTarget;
                    if (!this.contains(s)) {
                        $(this).css('background-color', '')
                    }

                })

                $('.label-question input').bind('input propertychange', function () {
                    var input_width = $(this).width();
                    var current_width = parseInt($(this).val().length) * 12;
                    if (input_width < current_width) {
                        if (current_width < 816) {
                            $(this).css('width', current_width)
                        } else {
                            $(this).css('width', '816px')
                        }
                    }
                })

                clearInterval(interval2);
            }
        }, 1000)
    }




    $('#mi-close').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
    })

    $('.sc-jNHqnW.iYzQjy.pf-cmIpgn').click(function () {
        eq_page()
    })

    // 2022 1107 
    // 客服 pc端
    $('.gatsby-image-wrapper').click(function () {


        if ($(window).width() < 764) {
            if ($('#mask-mobile').css('display') == 'none') {
                $('#mask-mobile').css('display', 'flex')
            } else {
                $('#mask-mobile').hide()
            }
        } else {
            if ($('#mask-phone').css('display') == 'none') {
                $('#mask-phone').show()
            } else {
                $('#mask-phone').hide()
            }
        }
    })


    //  cart 页面 提示框
    $(".js-deleteitem-ajax").on("click", function () {

    });
    $(".cart_dialog .btnnoOk ,.modal-backdrop").on("click", function () {
        $(".cart_dialog").css("display", "none");
        $('.modal-backdrop.fade').css('display', 'none').removeClass('show')
    });

    $("#delallpartdialog").on("click", ".btnok", function () {
        var index = $(this).attr('data-index');
        window.location.href = "/cart/change?line=" + index + "&amp;quantity=0"
        $(this).parents(".cart_dialog").css("display", "none");
        $('.modal-backdrop.fade').css('display', 'none').removeClass('show')
    });

    // 首页提示词隐藏
    if ($(window).width() <= 780) {
        $(window).scroll(function () {
            var top = $(document).scrollTop();
            if (top > 100) {
                $('.promo_banner').hide()

            } else {
                $('.promo_banner').show()
            }
        })

    }

    // 详情页滑动
    if (isTypeurl.indexOf('products') != -1) {
        if ($(window).width() > 780) {
            var interval3 = setInterval(() => {
                if ($('#bcpo').length > 0) {
                    var box_height = $('#purchase-details__buttons').offset().top;
                    var left_height = $('.nine.columns.alpha').height();
                    var box_top = $('.container.main.content').offset().top;
                    var scrollBottom = box_height + box_top;
                    var fheight = box_height - left_height;//左边剩下空的高度
                  if(fheight >100){
                    $(window).scroll(function () {
                        var scrollTop = $(window).scrollTop();
                        if (scrollTop >= box_top + 10 && scrollTop <= scrollBottom) {
                            $('.nine.columns.alpha').addClass('columns_active');
                            if (scrollTop >= fheight + box_top - 50) {
                                $('.gallery-wrap.js-product-page-gallery.clearfix.gallery-arrows--true.bottom-thumbnails.slideshow_animation--slide').css('top', (fheight - 97) + 'px').addClass('wrap_fix_bottom').removeClass('wrap_fix')
                            } else {
                                var wrapfixtop = '10px'
                                $('.gallery-wrap.js-product-page-gallery.clearfix.gallery-arrows--true.bottom-thumbnails.slideshow_animation--slide').addClass('wrap_fix').removeClass('wrap_fix_bottom').css('top', wrapfixtop)
                            }
                        } else {
                            $('.nine.columns.alpha').removeClass('columns_active');
                            $('.gallery-wrap.js-product-page-gallery.clearfix.gallery-arrows--true.bottom-thumbnails.slideshow_animation--slide').removeClass('wrap_fix')//当移到顶部时去掉
                        }
                    });
                    clearInterval(interval3);
                }
                }
            }, 1000);

        }
    }
    $('body').on("click", 'li .featured-links', function (e) {
        $('a.icon-cart.mini_cart.dropdown_link').trigger("click");
    });



})
function resetPassword(index) {
    var div = $("#delallpartdialog");
    div.find('.btnok').attr('data-index', index);
    div.css("display", "block");
    $('.modal-backdrop.fade').css('display', 'block').addClass('show')
}

function remove_add_cart() {
    $('#add_to_cart').removeAttr('style');
    $('#add_to_cart').parents('.purchase-details__buttons').removeAttr('style');
}

function hide_Shorts(selectedValue) {
    const $shortsOptions = $("input[name*='Logo Location(Optional)'][value='Shorts']");
    const $frontNumberTitles = $("input[name*='Front - Number(Shorts Number)']")
        .closest('.bcpo-text')
        .find('.bcpo-label .bcpo-title');

    if (selectedValue === 'Top') {
        $shortsOptions.parent().hide();
        $shortsOptions.prop('checked', false);
        $frontNumberTitles.text('Front - Number:');
    } else {
        $shortsOptions.parent().show();
        $frontNumberTitles.text('Front - Number(Shorts Number):');
    }
}


function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]); return null; //返回参数值
}

function removeTip() {
    $('.tip-top').remove();
}

function AddSize(goods_name) {
    var obj = $("div[class='selector-wrapper bcpo-simple bcpo-default']");
    var modal = '<a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 10px;display:inline-block;"><span class="icon-f-09"></span> Size guide</a>';
    if (typeof (obj.html()) == "undefined" || obj == null) {
        setTimeout(AddSize, 1000);
    }
    else {
        obj.each(function () {
         if ( $(this).find(".bcpo-label label .bcpo-title").text().indexOf('Size') != -1) {
                  $(this).find(".bcpo-label label").append(modal);
         } 
        });
      var html = '';
          if(goods_name.indexOf('soccer') > -1){
            html = '<p class="Size_Title Title_Men">Our soccer jerseys are slim fit;For a standard fit, go one size up;For casual wear, two sizes up is recommended for extra comfort.</p>'  
          }else if(goods_name.indexOf('softball') > -1){
            html = '<p class="Size_Title Title_Women">Our softball jerseys are Standard fit;For casual wear, one sizes up is recommended for extra comfort.</p>'   
          }else if(goods_name.indexOf('baseball') > -1){
            html = '<p class="Size_Title Title_Women">Our baseball jerseys are Standard fit;For casual wear, one sizes up is recommended for extra comfort.</p>'
          }
      if(html.length>1){
          $('#modalProductInfo .modal-body p.fi-text-align.fi-text-align-width').eq(0).before(html) 
          text = $('.uk-sex-fi .bcpo-front-button-label-custom.active').text()

        text = text.substring(0, text.length - 2);
        if($('.Title_'+text).length>0){
          $('.Title_'+text).show()
        }
  
      }
    }
}


function productCus(goods_name) {
      var _upload = $("#bcpo input[type='file']");
    if (_upload.attr("data-price") != null) {
        _upload.attr("accept", "image/png, image/jpeg,image/jpg");
        if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
            $("span[class='bcpo-title']").each(function () {
                var htm = $(this).html();
                var title = $(this).text();
                if (title == "Material*:") {
                    $(this).next().children().css("margin-left", "15px");
                }
                if (htm.indexOf('*') > -1) {
                    if(goods_name.indexOf('baseball') > -1 && htm.indexOf('Women\'s') > -1){
                    htm = htm.replace("*", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span> <span class='question_file'></span>");
                    htm1 = "<div class='wen-div-css-mobile wen-div-css-pc' style='width: 60%;display: block;'><span style='color:#524e4e;line-height: 20px;word-spacing: -1px;display: inline-block;'>Our women’s baseball jerseys have a slim fit. For a standard fit, size up;<br> for extra comfort, choose a looser size.</span></div>"
                    $(this).html(htm);
                    $(this).parent().after(htm1)
                      $(this).parents('label').css('padding-bottom','0px')
              }else{
                    htm = htm.replace("*", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span>");
                    $(this).html(htm);      
              }             
                }

              if (title.indexOf('Team Name Font:') !== -1) {

                const prevP = $('#bcpo').prev('p');
                if (prevP.length && prevP.html().includes('Premium Quality!')) {
                  prevP.hide();
                  $('#bcpo').after(prevP.html())
                }

              // 替换标题中的冒号为带红星
              htm = htm.replace(":", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span>:");
              $(this).html(htm);
            
              const $wrapper = $(this).parents('.selector-wrapper');
            
              $wrapper.find('.bcpo-image-parent').each(function () {
                const $parent = $(this);
                const $input = $parent.find('input[type="radio"]');
                const $label = $parent.find('label');
            
                // 获取文字样式名
                const styleText = $input.val();
                const styleId = styleText.replace(/\s+/g, '_');
                $label.attr('id', 'Black1252'+styleId);
            
                // 提取 label 中的背景图片 url
                const bgStyle = $label.attr('style') || '';
                const bgUrlMatch = bgStyle.match(/url\(['"]?(.*?)['"]?\)/);
                const bgUrl = bgUrlMatch ? bgUrlMatch[1] : '';
                
            
                // 避免重复插入 font-thumb-large
                if (bgUrl && styleText && $parent.find('.font-thumb-large').length === 0) {
                  const thumbHtml = `
                    <div class="font-thumb-large">
                      <img src="${bgUrl}" style="width: 100%;">
                      <div style="color: #fff; text-align: center; font-size: 12px; margin-top: 14px; margin-bottom: 6px;">
                        ${styleText}
                      </div>
                    </div>
                  `;
                  $parent.append(thumbHtml);
                }
              });
            
            if (window.innerWidth <= 768) {
              $(document).on('click', '.bcpo-image-parent', function (e) {
                e.stopPropagation(); // 防止冒泡导致奇怪滚动
            
                $('.font-thumb-large').hide();
                const $preview = $(this).find('.font-thumb-large');
                $preview.show();
              });
            
              // 点击空白处关闭
              $(document).on('click touchstart', function (e) {
                if (!$(e.target).closest('.bcpo-image-parent').length) {
                  $('.font-thumb-large').hide();
                }
              });
            }

            }

                if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
                    // htm = "<font size=\"-2\">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>";
                    // $(this).append(htm);
                }

                if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1 || htm.indexOf('Upload Logo') > -1) {
                    htm = htm.replace(":", "<span class='question_file'></span>: <div class='wen-div-css-mobile' ><span style='color:#524e4e;'>Don't upload copyrighted logos.</span></div>");
                    $(this).html(htm);
                }

                if (htm.indexOf('Logo Location(Optional)') > -1) {
                    htm = htm.replace(":", "<span class='question_file'></span>:");
                    htm1 = "<div class='wen-div-css-mobile' style='width: 83%;'><span style='color:#524e4e;'>If the option isn't available below, please leave a note in the order specifying the required location.</span></div>"
                    $(this).html(htm);
                    $(this).parent().after(htm1)
                }
                if (htm.indexOf('Choose Neckline') > -1) {
                    htm = ("<span>*</span>");
                    $(this).append(htm);
                }


            });
        }
        _upload.attr("onchange", "showFileName($(this))");
    }
    else {
        setTimeout(productCus, 3000);
    }
}


function Txtinput() {
    if ($("input[name='properties[Back Number]']").attr("data-price") != null) {
        //         不允许输入“|”
        $("input[type='text']").keyup(function () {
            if ($(this).val().indexOf("|") != -1) {
                $(this).val("");
            }
        });
        // 判断是ios还是安卓
        if (ios_or_android() == 'ios') {
            $("input[type='text']").on("keyup", function () {
                var param = $(this).val();
                $(this).val(param.replace(regRule, ""));
            })
        } else {
            $("input[type='text']").on("input", function () {
                var param = $(this).val();
                $(this).val(param.replace(regRule, ""));
            })
        }
    } else {
        setTimeout(Txtinput, 3000);
    }
}



/*
@功能：判断终端是ios还是安卓
 */
function ios_or_android() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
        return 'and';
    } else {
        return 'ios';
    }
}


function Addinfo() {
     var good_name = $('h1.product_name').text();
    if((good_name.indexOf('Baseball') != -1 || good_name.indexOf('Basketball') != -1 || good_name.indexOf('Hockey') != -1 || good_name.indexOf('Hoodie') != -1 || good_name.indexOf('Football') != -1) && (good_name.indexOf('Shorts') == -1 && good_name.indexOf('Shirt') == -1) && good_name.indexOf('Custom Cream Black Hockey Jersey') == -1&& good_name.indexOf('Custom Black White Pinstripe Black-White Authentic Baseball Good Game Family Community Jersey') == -1){
    var mi = $('input[type=radio][name="properties[Material*]"]').parent().parent().prev();
    var obj = $("div[class='selector-wrapper bcpo-simple bcpo-buttons']");
    if (typeof (obj.html()) == "undefined" || obj == null) {
        setTimeout(Addinfo, 1000);
    } else {
        var html = "<div class='scmi_div'><a href='javascript:void(0);' class='scmi'  onclick='ClickMi()'>Comparing Methods<a/></div>";
        mi.parent().append(html);
    }
    }

}



// check if input was not null, hide the "Blank(No Name/Number)" radio
function hideBlank() {
    var blank = $('input[type=radio][name="properties[Material*]"][value="Blank(No Name/Number)"]');
    var blank2 = $('input[type=radio][name="properties[Material*]"][value="Blank Jersey"]');
    var inputs = $('#bcpo').find('input[type=text]');
    var filePic = $("input[name='properties[Upload Logo]'] , input[name='properties[Team Logo]'], input[name='properties[Back Logo]']");
    inputs.each(function () {

        $(this).bind("input propertychange", function () {
            blank.parent().css("display", "none");
            blank2.parent().css("display", "none");

            var isEmpty = [].reduce.call(inputs, function (a, b) {
                return a && !b.value;
            }, true);
            isEmpty && blank.parent().css("display", "inline-block");
            isEmpty && blank2.parent().css("display", "inline-block");
        });
    });

    $(".bcpo-buttons").eq(1).on("click", "label", function () {
        if ($(this).text().indexOf("Blank") != -1) {
            filePic.parent().css("display", "none");
            filePic.parent().prev().css("display", "none");
            inputs.each(function () {
                $(this).prop("disabled", "disabled");
            });
        } else {
            filePic.parent().css("display", "");
            filePic.parent().prev().css("display", "");
            inputs.each(function () {
                $(this).prop("disabled", "");
            })
        }
    })
}


function ClickMi() {
    //wwh8.5新增
    $(".touchevents").css({
        overflow: 'hidden'
    })
    document.body.style.overflow = 'hidden';
    //wwh8.4新增
    document.getElementById("buttom-x").style.display = 'block';
    var mi_popup_height = $("#mi-popup-kk").height() + 25;
    var buttomleftvalue = ($('body').width() - $("#buttom-x").width()) > 0 ? ($('body').width() - $("#buttom-x").width()) : ($("#buttom-x").width() - $('body').width())
    $(".buttom-x").css({
        top: mi_popup_height + 'px',
        left: buttomleftvalue / 2 + 'px',
    })
    $("#mask-mi").css("height", $(document).height());
    $("#mask-mi").css("width", $(document).width());
    $("#mask-mi").show();
    var $Popup = $('.mi-popup-kk');
    var leftvalue = ($('body').width() - $Popup.width()) > 0 ? ($('body').width() - $Popup.width()) : ($Popup.width() - $('body').width())

    var topvalue = ($(window).height() - $Popup.height() - 350) >= 0 ? '3' : '4';

    $Popup.css({
        left: leftvalue / 2 + 'px',
        top: topvalue / 2 + "rem",
        display: 'block',
        position: 'fixed'
    });
    //wwh新增
    var _title = $(".product_name").html();
    if (_title.indexOf('Baseball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/baseball_219fd43a-4252-4517-9914-0e4c0b99a61e.jpg?v=1659596354");
    }
    if (_title.indexOf('Basketball') != -1) {
        if (_title.indexOf('Shorts') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/shorts.jpg?v=1659596354");
        } else if (_title.indexOf('Suit') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_suit_76acdc09-4ccb-4b27-ac73-7e4a75a2bd7a.jpg?v=1659596354");
        } else {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_da1ff709-2631-4755-9f3f-b3ae91d70c39.jpg?v=1659596354");
        }
    }
    if (_title.indexOf('Football') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/football_fe7e41e8-be36-4412-908f-bdf8a5f71f5e.jpg?v=1659596354");
    }
    if (_title.indexOf('Golf') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/golf.jpg?v=1659596354");
    }
    if (_title.indexOf('Hat') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hats.jpg?v=1659596354");
    }
    if (_title.indexOf('Hockey') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hockey.jpg?v=1659596354");
    }
    if (_title.indexOf('Hoodie') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hoodies.jpg?v=1659596354");
    }
    if (_title.indexOf('Pants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/pant.jpg?v=1659596354");
    }
    if (_title.indexOf('Soccer') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/soccer_b18e2250-daea-4aac-8bc8-dbe7fac31909.jpg?v=1659596354");
    }
    if (_title.indexOf('Jacket') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/JD22101901.jpg?v=1666168588");
    }
    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') < 0) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/t-shirt_96c8c99b-ee96-46b0-a4e2-eb668c723d15.jpg?v=1659596354");
    }

    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0278/0263/2328/files/TZ22082205-01.jpg?v=1665124550");
    }
    if (_title.indexOf('Jogger Sweatpants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/Blank.jpg?v=1667894022");
    }
  if (_title.indexOf('Volleyball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/AZ24072430.jpg?v=1722494930");
    }
}




function showFileName(is) {
    // 只绑定一次全局事件
    if (!$('body').data('bigtur-events-bound')) {
        $('body').data('bigtur-events-bound', true);

        $('body').on('click', '.bigtur_upload_img_item_del', function () {
            const $wrapper = $(this).closest('.selector-wrapper');
            $wrapper.find('.bigtur_upload_img_item').remove();
            $wrapper.find('input[type="file"]').val('');
            $wrapper.find('.bcpo-value').html('');

            const inputName = $wrapper.find('input[type="file"]').attr('name') || '';
            const match = inputName.match(/^properties\[(\d{1,2}(ST|ND|RD|TH))?\s?Upload Logo\]/);
            const prefix = match && match[1] ? match[1].trim() + ' ' : '';
            const targetName = `properties[${prefix}Logo Location(Optional)]`;

            const $matchedInputs = $('input[type="radio"][value="None"], input[type="checkbox"][value="None"]').filter(function () {
                return $(this).attr('name') === targetName;
            });

            $matchedInputs.parent().show();
        });

        $('body').on('click', '.spotlight', function () {
            const imgUrl = $(this).attr('data-src');
            if (imgUrl) {
                $('.bigtur_img_preview_img').attr('src', imgUrl);
                $('.bigtur_img_preview_modal').fadeIn(200);
            }
        });
        $('body').on('click', '.bigtur_img_preview_modal', function (e) {
            if (!$(e.target).closest('.img-preview-box').length) {
                $('.bigtur_img_preview_modal').fadeOut(200);
            }
        });
        $('body').on('click', '.bigtur_img_preview_bg, .bigtur_img_preview_del', function () {
            $('.bigtur_img_preview_modal').fadeOut(200);
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                $('.bigtur_img_preview_modal').fadeOut(200);
            }
        });
    }

    // 读取图片数据
    const blank = $('input[type=radio][name="properties[Material*]"][value="Blank(No Name/Number)"]');
    const filePic = is[0].files[0];
    const valFilePic = is.val().toLowerCase();

    if (!filePic) return;

    // 校验图片格式
    if (!/\.(jpg|jpeg|png)$/.test(valFilePic)) {
        is.val("");
        alert("Please upload pictures in png jpg format.");
        return false;
    }

    const reader = new FileReader();
    reader.onload = function (e) {
        const data = e.target.result;
        const image = new Image();

        image.onload = function () {
            const width = image.width;
            const height = image.height;

            if (width > 400 && height > 400) {
                const html = `
               <div class="bigtur_upload_img_item">
                <img class="upload_th_img" width="100" height="100" >    
                <div class="bigtur_upload_img_item_bg">
                  <span class="bigtur_upload_img_item_del"></span>
                  <div class="spotlight" data-src=""><img src="https://cdn.shopify.com/s/files/1/0445/3587/3698/files/magnifier_spotlight.png?v=1753172689" style="width: 20px !important; position: relative;top: 5px;left: -8px;"><span>Preview</span></div>
                </div>
              </div>`;

                is.parent().parent().append(html);

                const url = getObjectURL(filePic);
                is.parents('.bcpo-file').find('.upload_th_img').attr("src", url);
                is.parents('.bcpo-file').find('.spotlight').attr("data-src", url);

                blank.parent().hide();

                // 获取匹配元素
                const inputName = is.attr('name') || '';
                const match = inputName.match(/^properties\[(\d{1,2}(ST|ND|RD|TH))?\s?Upload Logo\]/);
                const prefix = match && match[1] ? match[1].trim() + ' ' : '';
                const targetName = `properties[${prefix}Logo Location(Optional)]`;

                const $matchedInputs = $('input[type="radio"][value="None"], input[type="checkbox"][value="None"]').filter(function () {
                    return $(this).attr('name') === targetName;
                });
                $matchedInputs.parent().hide();
                if (prefix == '1ST ') {
                    // 先检查是否已经添加过 delete-logo-btn-wrapper
                    if ($matchedInputs.parent().next('.delete-logo-btn-wrapper').length === 0) {
                        const html1 = `<div class="delete-logo-btn-wrapper">
                            <span class="delete-logo-btn delete-logo-btn-circle">&times;</span>
                        </div>`;
                        $matchedInputs.parent().after(html1);
                    }
                }


            } else {
                is.val("");
                alert("Sorry, the pixel of your image should be larger than 400*400, please upload again.");
                return false;
            }
        };
        image.src = data;
    };

if ($('.bigtur_img_preview_modal').length === 0) {
  $('body').append(`
    <div class="bigtur_img_preview_modal" style="display: none;">
      <div class="img-preview-layer">
        <div class="img-preview-box">
        
          <!-- 顶部栏 -->
          <div class="preview-header">
            <div class="title">Preview</div>
          </div>

          <!-- 中部图片区 -->
          <div class="preview-body">
            <img class="bigtur_img_preview_img" src="" />
          </div>

          <!-- 底部功能区 -->
          <div class="preview-footer">
              <div class="bigtur_img_preview_del">&times;</div>
          </div>

        </div>
      </div>
    </div>
  `);
}

    reader.readAsDataURL(filePic);
}



//自定义获取图片路径函数
function getObjectURL(file) {
    var url = null;
    if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
    } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
    } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
    }
    return url;
}


function getFileName(path) {
    var pos1 = path.lastIndexOf('/');
    var pos2 = path.lastIndexOf('\\');
    var pos = Math.max(pos1, pos2);
    if (pos < 0) {
        return path;
    }
    else {
        return path.substring(pos + 1);
    }
}


function eq_page() {
    // page 頁面
    var page = $('#shopify-section-template--16403274498296__pf-7fa86b28 .pf-c');
    $.each(page, function (index, item) {
        var interval3 = setInterval(() => {
            if ($(this).find('.is-visible').length > 0) {
                $(this).find('.splide__slide').eq(1).siblings().removeClass('is-active is-visible');
                $(this).find('.splide__slide').eq(1).addClass('is-active is-visible')
                clearInterval(interval3);
            }
        }, 2000)

    })
}

function hide_Upload(e,Upload_Logo) {
  var logo_val = $('input[name="properties[Logo Location(Optional)][]"]:checked , input[name="properties[Logo Location(Optional)]"]:checked ').val();
  var this_val = e.prev('input').val();
  if (logo_val != undefined) {
    if (logo_val != 'None') {
      if (this_val != 'None') {
        Upload_Logo.css("display", "block !important");;
        e.parents('.single-option-selector').find('input[value="None"]').removeAttr("checked");
      } else {
        Upload_Logo.css("display", "none !important");
        e.parents('.single-option-selector').find('input').removeAttr("checked");
      }
    } else {
      Upload_Logo.css("display", "none !important");
    }

  } else {
    if (e.parents('.single-option-selector').find('input').attr('name') == 'properties[Logo Location(Optional)][]') {
      Upload_Logo.css("display", "none !important");
    } else {
      if (this_val != "None") {
        Upload_Logo.css("display", "block !important");
      } else {
        Upload_Logo.css("display", "none !important");
      }
    }
  }

}

function FrontStyle(name) {
          const statusMap = {
            "Front Style 1": "Just Another Hand",
            "Front Style 2": "High School USA Serif",
            "Front Style 3": "High School USA Sans",
            "Front Style 4": "Akzidenz Grotesk Bold",
            "Front Style 5": "Alex Brush"
        };
    return statusMap[name];
}

function FrontStyleHtml() {
  html = `
  <div class="bcpo-label">
    <label>
      <span class="bcpo-title">Font Style:</span>
      <span class="bcpo-value" id="selectedFont">Choose one</span>
    </label>
  </div>
  
  <div class="custom-select-wrapper" style="position: relative; width: 300px;">
    <ul class="font-style-options" style="list-style: none; padding: 0; margin: 0; border: 1px solid #ccc; display: none; position: absolute; width: 100%; background: white; z-index: 10;">
      <li data-value="Front Style 1" style="padding: 8px; cursor: pointer;">Front Style 1</li>
      <li data-value="Front Style 2" style="padding: 8px; cursor: pointer;">Front Style 2</li>
      <li data-value="Front Style 3" style="padding: 8px; cursor: pointer;">Front Style 3</li>
      <li data-value="Front Style 4" style="padding: 8px; cursor: pointer;">Front Style 4</li>
      <li data-value="Front Style 5" style="padding: 8px; cursor: pointer;">Front Style 5</li>
    </ul>
    <input type="hidden" name="properties[Font Style]" id="selectedFontInput" />
  </div>
`

      $('#selectedFont').on('click', function () {
      $('.font-style-options').toggle();
    });
    $('.font-style-options li').on('click', function () {
      const value = $(this).data('value');
      $('#selectedFont').text(value);
      $('#selectedFontInput').val(value);
      $('.font-style-options').hide();
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.custom-select-wrapper').length) {
        $('.font-style-options').hide();
      }
    });

  return html;
}

// 0723 新增.修改

function add_button(goods_name) {
  document.getElementById("purchase-details__buttons").addEventListener("click", function () {
    const $bcpo = $('#bcpo');
    const Gender = $('input[name="properties[Gender*]"]:checked, input[name="properties[Gender]"]:checked');

    if ($bcpo.length === 0 || (Gender.length === 0 && goods_name.indexOf('hat') === -1)) {
      alert('Product customization information failed to load, please refresh the page and add to the shopping cart again!');
      return false;
    }

    const Material = $('input[value="Blank(No Name/Number)"]');
    const textInputs = $bcpo.find('input[type="text"]');
    const fileInput = $bcpo.find('input[type="file"]').get(0);
    const fileValue = fileInput ? fileInput.files[0] : undefined;
    const filenum = $bcpo.find('.upload_th_img');
    const ac = $('input[name="properties[A/C Patch on Left Chest (Optional)]"]:checked');
    const acValue = ac.length ? ac.val() : 'None';

    // 检查文字框是否填写
    let textFilled = false;
    textInputs.each(function () {
      if ($(this).val().trim().length > 0) {
        textFilled = true;
        return false;
      }
    });

    // 自动点击 Blank 选项
    if (!Material.is(":checked") && Material.length > 0) {
      if (!textFilled && !fileValue && filenum.length === 0 && acValue === 'None') {
        textInputs.prop("disabled", true);
        Material.trigger("click");
      }
    }

    // 检查 Logo 上传逻辑
    if (!fileValue && filenum.length === 0) {
      if (!checkLogoUpload()) return false;
    }

    // Pants 或 hat 时需填写文字或上传文件
    if (Material.length < 1 && (goods_name.indexOf('pants') > -1 || goods_name.indexOf('hat') > -1)) {
      if (!textFilled && !fileValue) {
        alert('Please fill in the commodity process information');
        return false;
      }
    }

    $('#add_to_cart').removeAttr('disabled').trigger("click");
  });
}

function checkLogoUpload() {
  const logoChecks = [
    {
      label: "1st Logo",
      locationNames: [
        'properties[1ST Logo Location(Optional)]',
        'properties[1ST Logo Location(Optional)][]'
      ],
      uploadNames: [
        'properties[1ST Upload Logo]',
        'properties[1ST Upload Logo][]'
      ]
    },
    {
      label: "2nd Logo",
      locationNames: [
        'properties[2ND Logo Location(Optional)]',
        'properties[2ND Logo Location(Optional)][]'
      ],
      uploadNames: [
        'properties[2ND Upload Logo]',
        'properties[2ND Upload Logo][]'
      ]
    }
  ];

  for (let check of logoChecks) {
    let locationInput = null;
    for (let name of check.locationNames) {
      locationInput = $('input[name="' + name + '"]:checked');
      if (locationInput.length > 0) break;
    }

    let uploadInput = null;
    for (let name of check.uploadNames) {
      uploadInput = $('input[name="' + name + '"]').filter('[type="file"]');
      if (uploadInput.length > 0) break;
    }

    console.log(uploadInput)
    if (locationInput.length && locationInput.val() !== 'None') {
      const $container = uploadInput.closest('.bcpo-file'); // ←根据你真实结构修改

      const hasPreview = $container.find('.upload_th_img').filter(function () {
        return $(this).attr('src')?.trim().length > 0;
      }).length > 0;

      const hasFile = uploadInput.get(0)?.files.length > 0;

      if (!hasPreview && !hasFile) {
        if ($container.find('.logo-upload-warning').length === 0) {
          const warningHtml = `
          <div class="logo-upload-warning">
            <div class="arrow-up"></div>
            <div class="warning-box">
              <div class="warning-text">
                <img src="https://cdn.shopify.com/s/files/1/0445/3587/3698/files/warn_icon_2ac28536-91c6-4178-915a-54df9ce634d5.png?v=1753176383" style=" width: 20px !important;height: 20px;margin-right: 8px;">
                <span>Please upload image for 1st Logo</span>
              </div>
            </div>
          </div>

          `;
          const $warning = $(warningHtml).appendTo($container);

          setTimeout(() => {
            $warning.fadeOut(300, function () {
              $(this).remove();
            });
          }, 3000);
        }
        return false;
      }
    }
  }

  return true;
}